import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    sassUser: null,
    organization: null,
    // organization: {
    //     organizationId: 97,
    //     organizationName: "Hr Organization",
    //     organizationAddress: "THub",
    //     organizationCity: "california",
    //     organizationCountry: "272",
    //     organizationType: 101390013,
    //     isActive: true,
    //     organizationState: "1",
    //     organizationDesc: "Hr Organization",
    //     certificateUrl:
    //         "https://doctorite-saas-uat.s3.us-west-2.amazonaws.com/org-certificates/pose-1.png",
    //     organizationLogo:
    //         "https://doctorite-saas-uat.s3.us-west-2.amazonaws.com/org-logos/logo.png",
    //     npiNumber: "test",
    //     licenseNo: "Hr Organization",
    //     active: true,
    // },
    // clinic: {
    //     clinicId: 191,
    //     clinicName: "Hr Organization",
    //     clinicAddress: "Hr Organization",
    //     clinicCity: "california",
    //     clinicState: "Alabama",
    //     clinicCountry: "USA",
    //     clinicPincode: 500087,
    //     clinicPhoneNo: "8639394843",
    //     clinicEmail: "saastest@gmail.com",
    //     isVerified: true,
    //     isActive: true,
    //     organizationId: 97,
    //     twilioFrom: "+18176702347",
    //     chargePerPatient: 48,
    //     commInPercent: 35,
    //     type: "Assisted Living Facility",
    //     licenseNo: "Hr Organization",
    //     certificateUrl:
    //         "https://doctorite-saas-uat.s3.us-west-2.amazonaws.com/org-certificates/pose-1.png",
    //     npiNumber: "test",
    // },
    // user: {
    //     userBean: {
    //         id: 0,
    //         userType: "consultant",
    //         userName: "fdsfds@gmail.com",
    //         password: "",
    //         entityId: 331,
    //         isActive: true,
    //         isBlocked: false,
    //         organizationId: 97,
    //         clinicId: 191,
    //         loginPhone: null,
    //         firstName: "Chaitanya",
    //         lastName: "Dharmgutte",
    //         mobileNumber: null,
    //         isDeleted: null,
    //         clinicName: null,
    //         timeZone: "",
    //         language: null,
    //         professionType: 100240006,
    //         professionTypeName: null,
    //         personalEmail: null,
    //         type: "Counselor",
    //         clinicsList: null,
    //         programListForUser: null,
    //         roles: null,
    //         blocked: false,
    //         active: true,
    //         deleted: null,
    //     },
    //     roleIds: ["Counselor_CUSTOM_97_191_35"],
    //     createdBy: null,
    //     roleLookupId: 101270013,
    //     programs: [1],
    // },
    user: null,
    isClinicAndOrganizationSame: false,
    clinic: null,
}

const onboardingSlice = createSlice({
    name: "onboarding",
    initialState,
    reducers: {
        updateSassUser: (state, action) => {
            state.sassUser = action.payload
        },
        updateOrganization: (state, action) => {
            state.organization = action.payload
        },
        updateClinic: (state, action) => {
            console.log("updating with data:", action.payload)
            state.clinic = action.payload
        },
        updateIsClinicAndOrganizationSame: (state, action) => {
            state.isClinicAndOrganizationSame = action.payload
        },
        updateUser: (state, action) => {
            state.user = action.payload
        },
    },
})

export const {
    updateSassUser,
    updateOrganization,
    updateClinic,
    updateIsClinicAndOrganizationSame,
    updateUser,
} = onboardingSlice.actions

export default onboardingSlice.reducer
